import {Component, OnInit} from '@angular/core';
import {InstituicaoRegime} from 'src/app/shared/models/instituicoes-regime.model';
import {InstituicoesRegimeService} from 'src/app/shared/services/instituicoes-regime.service';

@Component({
  selector: 'app-lista-instituicoes-regime',
  templateUrl: './lista-instituicoes-regime.component.html',
  styleUrls: ['./lista-instituicoes-regime.component.scss']
})
export class ListaInstituicoesRegimeComponent implements OnInit {
  dataAtual = ""
  date = new Date()

  slides: any[] = [[]]

  tableDataCard: InstituicaoRegime[] = []
  exibirCards: boolean = true

  constructor(private regimeService: InstituicoesRegimeService) {
  }

  ngOnInit(): void {
    this.listarInstituicoes()
    this.dataAtual = `${this.formataData(this.date.getDate())}/${this.formataData(this.date.getMonth())}/${this.date.getFullYear()}`
  }

  formataData(numero) {
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }

  listarInstituicoes() {
    this.regimeService.instituiçõesRegime().subscribe(
      res => this.tableDataCard = res["data"],
      e => console.log(e, "Houve erros ao listar as instituições em regime especial."),
      () => this.exibirCards = this.tableDataCard.length == 0 ? false : true
    )
  }
}
